<template>
  <div id="reward-detail">
    <div class="row">
      <div class="col-md-12">
        <h2>상품 상세</h2>
        <table class="table table-bordered">
          <tr>
            <th class="text-left">상품명</th>
            <td class="text-left">
              <input v-model="name" class="form-control" type="text" />
            </td>
          </tr>
          <tr>
            <th class="text-left">기준 금액</th>
            <td class="text-left">
              <input v-model="basePrice" class="form-control" type="text" />
            </td>
          </tr>
          <tr>
            <th class="text-left">금액</th>
            <td class="text-left">
              <input v-model="price" class="form-control" type="text" />
            </td>
          </tr>
          <tr>
            <th class="text-left">선착순</th>
            <td class="text-left">
              <input v-model="quantity" class="form-control" type="text" />
            </td>
          </tr>
          <tr>
            <th class="text-left">수강기간(월 단위)</th>
            <td class="text-left">
              <input v-model="validMonth" class="form-control" type="text" />
            </td>
          </tr>
          <tr>
            <th class="text-left">상품 보이기</th>
            <td class="text-left">
              <input v-model="isVisible" type="radio" value="1" :checked="isVisible" />보여주기
              <input v-model="isVisible" type="radio" value="0" :checked="!isVisible" />숨기기
            </td>
          </tr>
          <tr>
            <th class="text-left">상품 활성화</th>
            <td class="text-left">
              <input v-model="isActive" type="radio" value="1" :checked="isActive" />활성화
              <input v-model="isActive" type="radio" value="0" :checked="!isActive" />비활성화
            </td>
          </tr>
        </table>
        <ckeditor v-model="description" :editor="editor" :config="editorConfig" @ready="attachInspector"></ckeditor>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import inlineEditorConfig from '../mixins/InlineEditorConfig';
import helpers from '../helpers/helpers';

export default {
  mixins: [inlineEditorConfig],
  props: {
    reward: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    name: {
      get() {
        return this.$store.state.rewardEditor.name;
      },
      set(value) {
        this.$store.commit('updateRewardName', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    description: {
      get() {
        return this.$store.state.rewardEditor.description;
      },
      set(value) {
        this.commitUpdateRewardEditorDescriptionDebounced(value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    price: {
      get() {
        return this.$store.state.rewardEditor.price;
      },
      set(value) {
        this.$store.commit('updateRewardPrice', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    basePrice: {
      get() {
        return this.$store.state.rewardEditor.basePrice;
      },
      set(value) {
        this.$store.commit('updateRewardBasePrice', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    quantity: {
      get() {
        return this.$store.state.rewardEditor.quantity;
      },
      set(value) {
        this.$store.commit('updateRewardQuantity', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    isVisible: {
      get() {
        return this.$store.state.rewardEditor.isVisible;
      },
      set(value) {
        this.$store.commit('updateRewardIsVisible', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    isActive: {
      get() {
        return this.$store.state.rewardEditor.isActive;
      },
      set(value) {
        this.$store.commit('updateRewardIsActive', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
    validMonth: {
      get() {
        return this.$store.state.rewardEditor.validMonth;
      },
      set(value) {
        this.$store.commit('updateRewardValidMonth', value);
        EventBus.$emit('setIsSavedReward', false);
      },
    },
  },
  created() {
    this.initRewardEditor();
  },
  methods: {
    initRewardEditor() {
      this.$store.commit('createReward', this.reward);
    },

    commitUpdateRewardEditorDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateRewardDescription', helpers.replaceSmartQuotes(value));
    }, 100),
  },
};
</script>
